import { usePropertyLegalDescription } from '../../../queries/PropertyFields/NonRentalCoreFields';
import { TextBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../components/ApplicationQuestionReviewItem';

interface LegalDescriptionProps {
    propertyGuid: string;
    required?: boolean;
    isReview?: boolean;
}

export const LegalDescription: React.FC<LegalDescriptionProps> = ({ propertyGuid, required = false, isReview = false }) => {
    const label = 'Legal Description';
    const [legalDescription, set_legalDescription] = usePropertyLegalDescription(propertyGuid);
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={legalDescription}
                />
            ) : (
                <TextBox
                    value={legalDescription}
                    onChange={(value) => set_legalDescription(value)}
                    label={label}
                    required={required}
                    placeholder='e.g. Tax ID # or block & lot'
                />
            )}
        </>
    );
};
